import React, { memo } from "react";
import { Spinner, Text, useTheme } from "@bookingcom/bui-react";
import { I18nChildContext, t, useI18n } from "@bookingcom/lingojs-react";
import { UIProductType } from "@flights/types";
import Frame from "../../../../components/elements/Frame/Frame";
import { useSelector } from "react-redux";
import { getFlightDetailsFetchStatus } from "../../../../store/flightDetails/selectors";

export const LoadingAncillariesPrice = memo(function _LoadingAncillariesPrice({
  type,
  price,
  productTitle
}: {
  type: UIProductType;
  price: string;
  productTitle?: string;
}) {
  const i18n = useI18n() as I18nChildContext;
  const theme = useTheme();
  const fetchStatus = useSelector(getFlightDetailsFetchStatus);

  switch (fetchStatus) {
    case "loading":
      return (
        <>
          <Text variant="body_2">{price}</Text>
          <Frame direction="row">
            <Frame mr={2} attributes={{ style: { alignSelf: "center" } }}>
              <Spinner size={"small"} />
            </Frame>
            <Frame attributes={{ style: { color: theme.colors.color_foreground_alt } }}>
              <Text variant="small_1" color="neutral_alt">
                {getPriceLoadingText(type, i18n)}
              </Text>
            </Frame>
          </Frame>
        </>
      );
    case "failed":
      return (
        <Frame attributes={{ style: { color: theme.colors.color_foreground_alt } }}>
          <Text variant="body_2">{getPriceLoadingErrorText(type, i18n)}</Text>;
        </Frame>
      );
    case "success":
      return productTitle ? (
        <Text aria-label={`${productTitle}: ${price}`} variant="body_2">
          {price}
        </Text>
      ) : (
        <Text variant="body_2">{price}</Text>
      );
    default:
      return <Text variant="body_2">{price}</Text>;
  }
});

const getPriceLoadingText = (type: UIProductType, i18n: I18nChildContext) => {
  switch (type) {
    case "checkedInBaggage":
      return i18n.trans(t("flights_fd_extra_checked_bag_price_updating"));
    default:
      return i18n.trans(t("flights_fd_extra_cabin_bag_price_updating"));
  }
};

const getPriceLoadingErrorText = (type: UIProductType, i18n: I18nChildContext) => {
  switch (type) {
    case "checkedInBaggage":
      return i18n.trans(t("flights_fd_extra_checked_bag_price_updating_failed"));
    default:
      return i18n.trans(t("flights_fd_extra_cabin_bag_price_updating_failed"));
  }
};
